import { useScreenSize } from '@insight-health-ai/roseate/utils/hooks';
import { useState, useEffect } from 'react';
import { Progress } from 'src/components';

type VCALoaderProps = {
  loading: boolean;
  step: number;
};

export const VCALoader = ({ loading, step = 1 }: VCALoaderProps) => {
  const { mediaMax } = useScreenSize();
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    let timeout: NodeJS.Timeout;
    if (loading) {
      setOpen(true);
      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev < 75) {
            return prev + step;
          } else {
            return 75;
          }
        });
      }, 1000);
    } else {
      setProgress(100);
      timeout = setTimeout(() => {
        setOpen(false);
      }, 500);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [loading]);

  if (!open) return null;

  return (
    <div className="flex justify-center items-center absolute inset-0 bg-[rgba(0,0,0,0.2)] z-100">
      <div
        className={`${mediaMax('sm') ? 'w-11/12' : ''} px-10 py-10 bg-[#fff] flex items-center flex-col rounded-2xl shadow-md `}
      >
        <div className="text-[#000] font-semibold">
          Confirming we have everything needed. This may take up to 2 minutes
        </div>
        <div className="w-full mt-5">
          {/* @todo: Harshit | Migrate to roseate Progress component */}
          <Progress
            percent={progress}
            status="active"
            strokeColor={{ from: '#dafff3', to: '#00D090' }}
            showInfo={false}
          />
        </div>
      </div>
    </div>
  );
};
